import React, { useState} from 'react';
import { Calculator} from 'lucide-react';
import AnnouncementSection from './AnnouncementSection';
import { useNavigate } from 'react-router-dom';
import Loader from "../Loader"; 

const HeroSection = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleClick = () => {
    setLoading(true); // Show loader
    setTimeout(() => {
      setLoading(false); // Hide loader before navigation (optional)
      navigate("/Forms"); // Navigate after delay
    }, 2000); // Simulating 2 seconds of loading time
  };

  return (
    <div className="font-poppins mt-0 p-0" style={{ backgroundColor: '#faf9f6' }}>
    {/* Hero Section */}
    <div className="hero-container mx-auto px-6 sm:px-24 py-0 mb-24 mt-12 flex flex-col md:flex-row items-center justify-center md:justify-between md:space-x-6 space-y-6 md:space-y-0">
      {/* Left Column */}
      <div className="w-full md:w-1/2 text-center md:text-left">
        {/* Logo Image */}
        <div className="relative flex flex-col md:flex-row items-center md:items-start mb-4 md:mb-0">
          {/* Logo Image */}
          <img
            src="/Images/Logo.png"
            alt="Logo"
            className="w-32 mb-2 opacity-100 animate__animated animate__fadeInDown animate__delay-0.5s"
          />

          {/* Since 1999 */}
          <label
            className="block md:absolute md:left-40 md:bottom-2 text-lg md:text-xl font-extrabold text-left opacity-100 animate__animated animate__fadeInDown animate__delay-0.5s"
            style={{ color: '#3C6D9B' }}
          >
            Since 1999
          </label>
        </div>

        {/* Heading */}
        <h1
          className="text-3xl sm:text-3xl md:text-5xl font-extrabold mb-4 mt-4 text-center md:text-left opacity-0 animate__animated animate__fadeInDown animate__delay-0.5s"
          style={{
            color: '#4CAF50',
            wordBreak: 'break-word',
          }}
        >
          HIMANSHU SALARY CORNER
        </h1>

        {/* Subheading */}
        <p
          className="text-base md:text-1xl sm:text-lg md:text-lg font-semibold opacity-0 animate__animated animate__fadeInDown animate__delay-0.5s"
          style={{ color: '#707070' }}
        >
          Your trusted resource for employee salaries, pensions, and benefits in Maharashtra. Stay updated on pay commissions, allowances, arrears, and pay fixation with expert insights.
          </p>

    {/* Button */}
<div className="mt-16 flex justify-center md:justify-start">
{loading ? (
        <Loader /> // Show loader when loading
      ) : (
        <button className="relative px-8 py-3 text-white font-bold text-lg rounded-md flex items-center justify-center gap-3 hover:shadow-lg hover:shadow-green-500"
        style={{
          backgroundColor: '#3C6D9B',
        }}>
          <Calculator className="w-6 h-6" />
          <span className="ml-3 text-shadow" onClick={handleClick}>CALCULATE NOW!</span>
        </button>
         )}
        <style jsx>{`
              .text-shadow {
                color: white;
                text-shadow: 0 0 5px rgba(255, 255, 255, 0.6);
                transition: text-shadow 0.5s ease;
              }

              button:hover .text-shadow {
                text-shadow: 0 0 10px rgba(76, 175, 80, 1); /* Green text shadow */
              }

              button {
                transition: background 0.5s ease;
              }

              button:hover {
                background: linear-gradient(to right, rgba(76, 175, 80, 1), rgba(76, 175, 80, 1)); /* Full green gradient */
              }

              /* Adding shadow effect on hover */
              button:hover {
                box-shadow: 10px 10px 50px rgb(0, 0, 0); /* Green shadow around the button */
              }
            `}</style>

      </div>
    </div>

{/* Right Column (Announcement Section) */}

<AnnouncementSection/>
</div>
</div>
  );
};

export default HeroSection;
